<!--
  群主成员
  lovi 2020-06-22
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="groupName"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="scroll-wrapper">
      <div class="group-wrap">
        <div class="group-title">
          <span>
            {{ $t("transfer.memberList") }}
            ({{ listMember.length }}人)
          </span>
          <span class="text-blue" @click="setFlag = true">
            {{ $t("common.setting") }}
          </span>
        </div>
        <div class="group-operate">
          <div class="item" @click="groupOperate('add')">
            <i class="add"></i>
            <span>{{ $t("transfer.addTeamMembers") }}</span>
          </div>
          <div
            class="item"
            :class="{ disabled: !listMember.length }"
            @click="groupOperate('del')"
          >
            <i class="del"></i>
            <span>{{ $t("transfer.delTeamMembers") }}</span>
          </div>
        </div>
        <div class="group-list">
          <van-cell
            v-for="(item, index) in listMember"
            :key="index"
            :icon="httpUrl + item.avatar"
            :title="item.username"
            :label="_phoneDispose(item.phone)"
          />
        </div>
      </div>
    </div>
    <div class="button-wrap button-fixed">
      <van-button block type="primary" @click="toTransfer">
        {{ $t("transfer.toTransfer") }}
      </van-button>
    </div>
    <!-- 添加成员 -->
    <transition name="slide">
      <members-add
        v-if="membersAddFlag"
        :membersAddFlag.sync="membersAddFlag"
        :membersInfoFlag.sync="membersInfoFlag"
        @getAmountData="getAmountData"
      />
    </transition>
    <!-- 成员查询信息 -->
    <transition name="slide">
      <members-info
        v-if="membersInfoFlag"
        :membersAddFlag.sync="membersAddFlag"
        :membersInfoFlag.sync="membersInfoFlag"
        :data="amountData"
        :groupId="data.group_id"
        @getListMember="getListMember"
      />
    </transition>
    <!-- 删除成员 -->
    <transition name="slide">
      <members-del
        v-if="membersDelFlag"
        :membersDelFlag.sync="membersDelFlag"
        :groupId="data.group_id"
        @getListMember="getListMember"
      />
    </transition>
    <!-- 设置 -->
    <van-action-sheet
      v-model="setFlag"
      class="set-action"
      :cancel-text="$t('common.cancel')"
    >
      <ul>
        <li @click="modifyGroupName">{{ $t("transfer.modifyName") }}</li>
        <li @click="delGroup">{{ $t("transfer.delTransferGroup") }}</li>
      </ul>
    </van-action-sheet>
    <!-- 设置转账组名称 -->
    <van-dialog
      v-model="groupNameFlag"
      :title="$t('transfer.setTransferGroupName')"
      show-cancel-button
      @confirm="editTransferGroup"
    >
      <!-- <p class="changeTips">只能输入2-12个中英文或数字</p> -->
      <van-field
        class="dialog-input"
        :error="groupNameError ? true : false"
        @input="groupNameInput"
        :placeholder="$t('transfer.enterTransferGroupName')"
        v-model="editGroupName"
      />
    </van-dialog>
    <!-- 去转账 -->
    <transition name="slide">
      <transfer
        v-if="transferFlag"
        :transferFlag.sync="transferFlag"
        :list="transferList"
      />
    </transition>
  </div>
</template>

<script>
import * as validate from "@/commonJs/validate.js";
import MembersAdd from "./membersAdd";
import MembersInfo from "./membersInfo";
import MembersDel from "./membersDel";
import Transfer from "../transfer";
export default {
  props: {
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: {
    MembersAdd,
    MembersInfo,
    MembersDel,
    Transfer
  },
  data() {
    return {
      listMember: [],
      groupName: "", // 群组昵称
      membersAddFlag: false, // 添加成员Flag
      membersInfoFlag: false, // 成员InfoFlag
      amountData: {}, // 成员InfoData
      membersDelFlag: false, // 删除成员Flag
      setFlag: false, // 设置Flag
      groupNameFlag: false, // 群组昵称Flag
      editGroupName: "", // 修改群组昵称
      groupNameError: false, // 群组昵称报错
      transferFlag: false, // 去转账
      transferList: []
    };
  },
  created() {
    this.getListMember();
    this.groupName = this.data.group_name;
  },
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:groupMembersFlag", false);
    },
    toTransfer() {
      // 去转账
      let vm = this;
      vm.transferList = [];
      for (let i = 0; i < vm.listMember.length; i++) {
        let obj = {};
        obj = vm.listMember[i];
        obj.money = "";
        vm.transferList.push(obj);
      }
      console.log("transferList", vm.transferList);
      vm.transferFlag = true;
    },
    modifyGroupName() {
      // 修改群名称
      this.groupNameFlag = true;
      this.setFlag = false;
    },
    groupNameInput() {
      // 群昵称Input
      this.groupNameError = validate.validateGroupName(this.editGroupName);
    },
    editTransferGroup() {
      // 编辑群昵称
      let vm = this;
      if (vm.editGroupName == "") {
        return;
      }
      if (vm.groupNameError) {
        vm.$toast(vm.groupNameError);
        vm.editGroupName = "";
        return;
      }
      let params = {};
      params.group_id = vm.data.group_id;
      params.group_name = vm.editGroupName;
      vm.$post("/app/transfer/editTransferGroup", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("editTransferGroup", res);
        if (res.code == 0) {
          vm.editGroupName = "";
          vm.groupName = params.group_name;
          vm.$emit("getListTransferGroup");
        }
        vm.$toast(res.msg);
      });
    },
    delGroup() {
      let vm = this;
      vm.setFlag = false;
      vm.$dialog
        .confirm({
          message: vm.$t("transfer.sureDelete")
        })
        .then(() => {
          // 确定删除
          vm.delTransferGroup();
        })
        .catch(() => {});
    },
    delTransferGroup() {
      // 删除群组
      let vm = this;
      let params = {};
      params.group_id = vm.data.group_id;
      vm.$post("/app/transfer/delTransferGroup", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("delTransferGroup", res);
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm.$emit("getListTransferGroup");
          vm.$emit("update:groupMembersFlag", false);
          vm.$emit("getListTransferGroup");
        }
      });
    },
    groupOperate(flag) {
      // 群组操作
      console.log("flag", flag);
      if (flag == "add") {
        this.membersAddFlag = true;
      }
      if (flag == "del") {
        if (this.listMember.length) {
          this.membersDelFlag = true;
        }
      }
    },
    getAmountData(data) {
      // 获取账号信息
      console.log("amountData", data);
      this.amountData = data;
    },
    getListMember() {
      // 获取群组成员
      let vm = this;
      vm.$post(
        "/app/transfer/listMember",
        { group_id: vm.data.group_id },
        { loading: true }
      ).then(res => {
        console.log("listMember", res);
        vm.listMember = res.list;
      });
    }
  },
  watch: {
    groupNameFlag() {
      this.editGroupName = "";
    }
  }
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.scroll-wrapper {
  bottom: 85px;
}
.set-action {
  ul li {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    font-size: 16px;
    border-bottom: 1.1px solid #e4e4e4;
  }
  /deep/.van-action-sheet__gap {
    height: 0;
  }
}
.group-wrap {
  padding: 0 15px;
}
.group-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  height: 40px;
  font-size: 14px;
  line-height: 1.2;
}
.group-operate {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0;
  font-size: 14px;
  border-bottom: 1.1px solid #e4e4e4;
  .item {
    width: 50%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    &.disabled {
      opacity: 0.5;
    }
    i {
      margin-right: 10px;
      width: 44px;
      height: 44px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100%;
      &.add {
        background-image: url("@{images}wallet/transfer/icon_add@2x.png");
      }
      &.del {
        background-image: url("@{images}wallet/transfer/icon_del@2x.png");
      }
    }
  }
}

.group-list {
  /deep/.van-cell {
    position: relative;
    align-items: center;
    padding: 10px 0;
    &::after {
      left: 54px;
    }
    .van-cell__left-icon {
      margin-right: 10px;
      width: 44px;
      height: 44px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100%;
      img {
        width: 44px;
        height: 44px;
        border-radius: 4px;
      }
    }
  }
}
</style>
